import { createContext } from 'react';

export const TimeTrackerMenuContext = createContext(null);
